module.exports = __webpack_public_path__ + "static/media/top-help.5aa8588e.png";